<section [formGroup]="stepForm">
  @if (isRDMode) {
    <header class="mb-4">
      <div class="text-xs">
        <div class="form-row">
          <div class="col-auto">
            {{ isUnix ? (isMac ? 'Example: /Users' : 'Example: /home/user') : 'Example:' }}
          </div>
          @if (!isUnix) {
            <div class="col">
              D:\folder\subfolder <br />
              %userprofile%\folder
            </div>
          }
        </div>
      </div>
    </header>
  }

  @if (!isVMRestore && !isRestoreDB) {
    <mbs-form-group>
      <mbs-button
        type="primary"
        [isCtrl]="true"
        (click)="showLegend()">
        {{ 'wizards:show_legend_text' | i18next }}
      </mbs-button>
    </mbs-form-group>
  }

  @if (agentCanSearch) {
    <mbs-input
      class="d-block mb-2"
      [appendButtons]="
        existSearchResult
          ? [
              {
                type: 'secondary',
                id: searchButtonsId.search,
                icon: 'ico ico-Search',
                loading: searchLoading,
                disabled: !searchString || searchLoading
              },
              {
                icon: 'fa fa-save',
                id: searchButtonsId.edit,
                blurAfterClick: true,
                type: 'secondary',
                disabled: searchLoading,
                tooltip: ('shared:sidepanel-backup.backupStorages.browseStorage.previousSearchResult' | i18next)
              }
            ]
          : [
              {
                type: 'secondary',
                id: searchButtonsId.search,
                icon: 'ico ico-Search',
                loading: searchLoading,
                disabled: !searchString || searchLoading
              }
            ]
      "
      [autocomplete]="'new-password'"
      [clearButton]="true"
      [name]="'restore-source-search-field'"
      [ngModelOptions]="{ standalone: true }"
      [placeholder]="'shared:placeholders.searchRequest' | i18next"
      [size]="MbsSize.sm"
      [(ngModel)]="searchString"
      (buttonClick)="searchClickHandler($event)"
      (keydown.enter)="searchClickHandler()">
    </mbs-input>
  }

  <mbs-form-group class="restore-source-tree position-relative">
    @if (!isRDMode) {
      <mbs-card
        [innerBordered]="true"
        [size]="MbsSize.sm"
        [staticHeight]="'calc(70vh - ' + minusPixels + 'px)'">
        @if (loadingTree) {
          <mbs-loader [size]="'small'"></mbs-loader>
        }

        @if (!treeData.length) {
          <mbs-alert
            class="mb-0 mt-3"
            [icon]="true"
            [type]="mbsPopupType.warning">
            {{ 'wizards:no_data_to_restore' | i18next }}
          </mbs-alert>
        }

        <mbs-tree
          *ngIf="treeData.length && stepFocused && (!mainLoading || treeData.length > 1)"
          classesForRoot="restore-source-tree"
          mode="file"
          [childrenManualControl]="true"
          [classesForRoot]="
            isVMRestore && (isNBF || !manually) ? 'restore-source-tree restore-source-tree_not-padding' : 'restore-source-tree'
          "
          [data]="treeData"
          [disableChildren]="false"
          [disableIfLoadingSubtree]="true"
          [getItems]="getSubtree.bind(this)"
          [height]="'calc(70vh - ' + minusPixels + 'px)'"
          [itemsCanBeHidden]="true"
          [lazy]="true"
          [loadMore]="getSubtree.bind(this)"
          [offCheckAndIndeterminate]="true"
          [onlyOneSelect]="isVMRestore && !isNBF && manually"
          [recursiveCheck]="!isVMRestore || isNBF || !manually"
          [virtualItemSize]="40"
          [virtualItemsNumber]="10"
          [virtualScroll]="true"
          (mbsChange)="changeTreeHandler($event)">
          <ng-template
            let-item
            treeElement>
            <div class="d-flex align-items-center">
              <img
                alt=""
                class="mr-2"
                [class.restore-source-tree_img-version]="item.isVersion || isVMRestore || this.isRestoreDB"
                [src]="item.icon" />
              {{ item.label }}
            </div>
          </ng-template>
        </mbs-tree>
      </mbs-card>
    }

    <mbs-form-group [hidden]="!isRDMode">
      <mbs-form-group [formGroup]="foldersForm">
        <mbs-files-folders-list
          #fileFoldersComponent
          formControlName="filesFoldersData"
          [isUnix]="isUnix"
          [labelForEnabledFields]="'wizards:excludeText' | i18next"
          [needShowEnabled]="false"
          [showItem]="isRDMode"></mbs-files-folders-list>
      </mbs-form-group>
    </mbs-form-group>
  </mbs-form-group>

  @if (notSelectedPoint) {
    <mbs-alert
      class="mb-0 mt-3"
      [icon]="true"
      [type]="mbsPopupType.danger">
      {{ 'wizards:selectRestorePoint' | i18next }}
    </mbs-alert>
  }

  @if (!isVMRestore && !isRestoreDB) {
    <mbs-alert
      class="mb-0 mt-3"
      [icon]="true"
      [type]="mbsPopupType.info">
      <span *ngFor="let item of restoreSourceInfoAlert; let i = index">
        @if (i === 1) {
          <a
            class="mx-1"
            target="_blank"
            [helpLink]="'/backup-and-restore/backup-plans/file-level-backup'"
            >{{ item }}</a
          >
        } @else {
          {{ item }}
        }
      </span>
    </mbs-alert>
  }

  @if (isVMRestore || isRestoreDB) {
    <mbs-alert
      class="mb-0 mt-3"
      [icon]="true"
      [type]="mbsPopupType.info">
      {{ 'wizards:restoreSourceVMInfoAlert.mainText' | i18next }}
      <ul class="pl-4">
        <li>{{ 'wizards:restoreSourceVMInfoAlert.first' | i18next }}</li>
        <li>{{ 'wizards:restoreSourceVMInfoAlert.second' | i18next }}</li>
      </ul>
    </mbs-alert>
  }
</section>
